import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import Header from 'App/Header'
import HeaderMeuNegocio from 'HomePageItauMeuBairro/Header'
import { FooterContainer } from 'App/Footer'
import FooterMeuNegocio from 'HomePageItauMeuBairro/Footer'
import FingerPrintContainer from 'App/FingerPrint/FingerPrintContainer'
import Widgets from 'Widgets'

import { useLastLocation } from 'react-router-last-location'

const Shell = ({ children, profile }) => {
  const [ headBairro, useHeadBairro ] = useState(false)
  useEffect(() => {
    if (children.props.children.props.path === '/meu-negocio') {
      useHeadBairro(true)
    }
  }, [])
  const refererIsLogin = () => (
    (typeof useLastLocation() !== 'undefined' && useLastLocation()) && (useLastLocation().pathname.toString().indexOf('auth') > -1)
  )

  return (
    <div className='bg-ui-4' data-campaign={process.env.REACT_APP_CATALOG_ID}>
      { refererIsLogin() && <FingerPrintContainer /> }
      { headBairro ? <HeaderMeuNegocio /> : <Header refererIsLogin={refererIsLogin()} />}
      <div className='container-fluid px-0 py-0' role='main'>
        {children}
      </div>
      { headBairro ? <FooterMeuNegocio /> : <FooterContainer /> }
      {profile && <Widgets />}
    </div>
  )
}

Shell.propTypes = {
  children: PropTypes.node,
  profile: PropTypes.object
}

export default Shell



// WEBPACK FOOTER //
// ./src/App/Shell/Shell.js